module.exports = __webpack_public_path__ + "static/media/2.f0d9808b.png";